module.exports = __webpack_public_path__ + "img/mmd-icon-info.0819e27.png";


//////////////////
// WEBPACK FOOTER
// ./resources/nuxt/assets/images/mmd-icon-info.png
// module id = JgqK
// module chunks = 14